"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hashing = void 0;
const cids_1 = __importDefault(require("cids"));
const multihashing_async_1 = __importDefault(require("multihashing-async"));
class Hashing {
    /** Given a set of files, return a map with their hash */
    static async calculateHashes(files) {
        const entries = Array.from(files)
            .map(async (file) => ({ hash: await this.calculateHash(file), file }));
        return Promise.all(entries);
    }
    /** Return the given file's hash */
    static async calculateHash(file) {
        return this.calculateBufferHash(file.content);
    }
    /** Return the given buffer's hash */
    static async calculateBufferHash(buffer) {
        const hash = await multihashing_async_1.default(buffer, "sha2-256");
        return new cids_1.default(0, 'dag-pb', hash).toBaseEncodedString();
    }
}
exports.Hashing = Hashing;
//# sourceMappingURL=Hashing.js.map